import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import staff2 from '../../../../images/staff/member_1.png';
import DatePicker, { DateObject } from "react-multi-date-picker";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

const UserEdit = ({ show, onClose, data, refresh }) => {
    const navigate = useNavigate();

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [selectedType, setSelectedType] = useState('1');
    const [exit_start_date, setSDate] = useState(null);
    const [exit_end_date, setEDate] = useState(null);
    const [exit_reason, setReason] = useState('');

    const [leads, setleads] = useState([]);
    const [isTransfer, setIsTransfer] = useState(true);
    const [lead_counts, setcounts] = useState(0);

    const [is_transfer_all, setTransfAll] = useState(false);

    useEffect(() => {
        if (data.jobrole_id === 2) {
            axios.get(`${baseURL}/managelead/get_transfer_leads/${data.sno}`)
                .then(resp => {
                    setleads(resp.data.leads);
                    if (resp.data.is_transfer === 0) {
                        setIsTransfer(false);
                    }
                    setcounts(resp.data.lead_count);
                }).catch(error => {
                    console.log(error);
                });
        }
    }, [data]);

    const [staffoption, setstaffopt] = useState([]);
    const [staff, setstaff] = useState(null);
    useEffect(() => {
        if (data) {
            axios.get(`${baseURL}/dropdown/get_sales_staffs`, { params: { branch_id } })
                .then(response => {
                    const formattedsource = response.data.data.filter(item => item.sno !== data.sno).map(item => ({
                        value: item.sno,
                        label: item.employee_name,
                    }));
                    setstaffopt(formattedsource);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }, [data]);

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        if (selectedType === '1') {
            if (!exit_start_date) {
                newErrors.sdate = "This Field is Required.";
            }
            if (!exit_end_date) {
                newErrors.edate = "This Field is Required.";
            }
            if (!exit_reason) {
                newErrors.reason = "This Field is Required.";
            }
        }

        if (selectedType === '2') {
            if (!exit_reason) {
                newErrors.reason = "This Field is Required.";
            }
        }

        if (selectedType === '3') {
            if (!exit_reason) {
                newErrors.reason = "This Field is Required.";
            }
        }

        if (selectedType === '4') {
            if (!exit_reason) {
                newErrors.reason = "This Field is Required.";
            }
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        let exit_type = 1;
        if (selectedType === '1') {
            exit_type = 1;
        } else if (selectedType === '2') {
            exit_type = 2;
        } else if (selectedType === '3') {
            exit_type = 3;
        } else if (selectedType === '4') {
            exit_type = 4;
        }

        const postData = {
            exit_type: exit_type, exit_start_date: exit_start_date, exit_end_date: exit_end_date, exit_reason: exit_reason
        };

        // console.log(postData);

        axios.put(`${baseURL}/managestaff/exit/${data.sno}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Staff Exit Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Staff Exit Failed");
            });
    };

    useEffect(() => {
        setSDate(null);
        setEDate(null);
        setReason('');
        setErrors({})
    }, [selectedType]);

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // display names
    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    // navigate lead
    const handleManualTransfer = () => {
        navigate("/manage-lead");
    };

    // display selection
    const handleAllTransfer = () => {
        setTransfAll(true);
    };

    // transfer validate
    const validateLeds = () => {
        const newErrors = {};
        
        if (!staff) {
            newErrors.staff = "This Field is Required.";
        }

        return newErrors;
    };

    // transfer lead
    const handleSubmitLeads = (event) => {
        event.preventDefault();

        const validationErrors = validateLeds();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { 
            branch_id: branch_id,
            leads: leads,
            staff_id: staff.value,
            staff_name: staff.label,
            user_id: user_id
        };

        axios.post(`${baseURL}/managelead/bulk_transfer_leads`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Lead Transferred Successfully!");
               
            }).catch(error => {
                onClose();
                console.log(error);
                refresh();
                toast.error("Lead Transferred Failed");
            });
    };


    return (
        <Modal className="modal fade" show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <div className='d-flex align-items-center gap-3 flex-wrap'>
                        <h3 className="modal-title text-white">Exit Status</h3>
                    </div>
                    <Button variant="" type="button" className="close px-6 py-2 text-white" onClick={onClose}>
                        <span>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    {/* info */}
                    <div className='row mb-2'>
                        <div className='col-lg-4 mb-1 d-flex justify-content-center'>
                            <LightGallery
                                onInit={onInit}
                                speed={500}
                                plugins={[lgThumbnail, lgZoom]}
                            >
                                <div data-src={data.staff_image_url ? data.staff_image_url : staff2}>
                                    <img src={data.staff_image_url ? data.staff_image_url : staff2} alt={data.employee_name} className='cursor-pointer w-125px h-125px' />
                                </div>
                            </LightGallery>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Staff Name</label>
                                <label className='text-danger font-w500 fs-6'>{capitalizeFirstLetter(data.employee_name)}</label>
                            </div>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Date of Joining</label>
                                <label className='text-danger font-w500 fs-6'>{formatDate(data.date_of_joining)}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Position</label>
                                <label className='text-danger font-w500 fs-6'>{data.position}</label>
                            </div>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Department</label>
                                <label className='text-danger font-w500 fs-6'>{data.department?.department_name ?? 'N/A'}</label>
                            </div>
                        </div>
                    </div>

                    {isTransfer === true ? (
                        <>
                            {/* exit type */}
                            <div className="col-lg-12 mb-2">
                                <div className="row mb-3">
                                    <div className="col-lg-12 d-flex justify-content-center align-items-center flex-wrap">
                                        <div className="form-check  col-lg-3">
                                            <input
                                                className="form-check-input me-1"
                                                type="radio"
                                                name="product_type"
                                                value="1"
                                                checked={selectedType === "1"}
                                                onChange={(e) => setSelectedType(e.target.value)}
                                            />
                                            <label className="form-check-label text-black font-w400 fs-7">
                                                Notice Period
                                            </label>
                                        </div>

                                        <div className="form-check  col-lg-3">
                                            <input
                                                className="form-check-input me-1"
                                                type="radio"
                                                name="product_type"
                                                value="2"
                                                checked={selectedType === "2"}
                                                onChange={(e) => setSelectedType(e.target.value)}
                                            />
                                            <label className="form-check-label text-black font-w400 fs-7">
                                                Releave
                                            </label>
                                        </div>

                                        <div className="form-check  col-lg-3">
                                            <input
                                                className="form-check-input me-1"
                                                type="radio"
                                                name="product_type"
                                                value="3"
                                                checked={selectedType === "3"}
                                                onChange={(e) => setSelectedType(e.target.value)}
                                            />
                                            <label className="form-check-label text-black font-w400 fs-7">
                                                Abscond
                                            </label>
                                        </div>

                                        <div className="form-check  col-lg-3">
                                            <input
                                                className="form-check-input me-1"
                                                type="radio"
                                                name="product_type"
                                                value="4"
                                                checked={selectedType === "4"}
                                                onChange={(e) => setSelectedType(e.target.value)}
                                            />
                                            <label className="form-check-label text-black font-w400 fs-7">
                                                Terminate
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* form */}
                            <div className='col-lg-12'>
                                <div className='row'>
                                    {/* notice period */}
                                    {selectedType === "1" && (
                                        <>
                                            <div className="col-lg-6 mb-2">
                                                <label className="text-black font-w500 fs-7">Start Date <span className="required">*</span></label>
                                                <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                                                    <div className='input-group-text bg-transparent border-0 px-0 rounded-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker placeholder='Select Date'
                                                        format="DD-MM-YYYY"
                                                        minDate={new Date(new Date().setHours(0, 0, 0, 0))}
                                                        onChange={(date) => setSDate(date.format('YYYY-MM-DD'))}
                                                    />
                                                </div>
                                                {errors.sdate && <div className="text-danger fs-8 mt-1">{errors.sdate}</div>}
                                            </div>
                                            <div className="col-lg-6 mb-2">
                                                <label className="text-black font-w500 fs-7">End Date <span className="required">*</span></label>
                                                <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                                                    <div className='input-group-text bg-transparent border-0 px-0 rounded-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker placeholder='Select Date'
                                                        format="DD-MM-YYYY"
                                                        minDate={new Date(new Date().setHours(0, 0, 0, 0))}
                                                        onChange={(date) => setEDate(date.format('YYYY-MM-DD'))}
                                                    />
                                                </div>
                                                {errors.edate && <div className="text-danger fs-8 mt-1">{errors.edate}</div>}
                                            </div>
                                            <div className="col-lg-12 mt-2 mb-3">
                                                <label className="text-black font-w500 fs-7">Reason<span className="required">*</span></label>
                                                <textarea rows={8} className="form-control" name="comment" placeholder="Reason"
                                                    maxLength={200}
                                                    onChange={(e) => setReason(e.target.value)}
                                                    value={exit_reason}
                                                />
                                                {errors.reason && <div className="text-danger fs-8 mt-1">{errors.reason}</div>}
                                            </div>
                                        </>
                                    )}

                                    {/* releave */}
                                    {selectedType === "2" && (
                                        <>
                                            <div className="col-lg-12 mt-2 mb-3">
                                                <label className="text-black font-w500 fs-7">Reason<span className="required">*</span></label>
                                                <textarea rows={8} className="form-control" name="comment" placeholder="Reason"
                                                    maxLength={200}
                                                    onChange={(e) => setReason(e.target.value)}
                                                />
                                                {errors.reason && <div className="text-danger fs-8 mt-1">{errors.reason}</div>}
                                            </div>
                                        </>
                                    )}

                                    {/* abscond */}
                                    {selectedType === "3" && (
                                        <>
                                            <div className="col-lg-6 mb-2">
                                                <label className="text-black font-w500 fs-7">Last Attend Date</label>
                                                <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                                                    <div className='input-group-text bg-transparent border-0 px-0 rounded-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker placeholder='Select Date'
                                                        format="DD-MM-YYYY"
                                                        minDate={new Date(new Date().setHours(0, 0, 0, 0))}
                                                        onChange={(date) => setSDate(date.format('YYYY-MM-DD'))}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 mb-3">
                                                <label className="text-black font-w500 fs-7">Reason<span className="required">*</span></label>
                                                <textarea rows={8} className="form-control" name="comment" placeholder="Reason"
                                                    maxLength={200}
                                                    onChange={(e) => setReason(e.target.value)}
                                                />
                                                {errors.reason && <div className="text-danger fs-8 mt-1">{errors.reason}</div>}
                                            </div>
                                        </>
                                    )}

                                    {/* terminate */}
                                    {selectedType === "4" && (
                                        <>
                                            <div className="col-lg-12 mt-2 mb-3">
                                                <label className="text-black font-w500 fs-7">Reason<span className="required">*</span></label>
                                                <textarea rows={8} className="form-control" name="comment" placeholder="Reason"
                                                    maxLength={200}
                                                    onChange={(e) => setReason(e.target.value)}
                                                />
                                                {errors.reason && <div className="text-danger fs-8 mt-1">{errors.reason}</div>}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* submit */}
                            <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                                <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Submit Exit <i className="fas fa-angle-double-right ms-2"></i></button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className='row mb-4'>
                                <div className='col-lg-12'>
                                    <div className='border rounded mt-4 border-warning bgl-warning py-2'>
                                        <p className="text-black fs-6 m-0 text-center">Pending Lead Transfer</p>
                                        <p className="text-black fs-5 m-0">
                                            <div className='text-danger font-w600 fs-5 text-center'>
                                                <label className='fs-2'>{lead_counts}</label>
                                            </div>
                                        </p>
                                        <p className="text-black fs-5 m-0 text-center">
                                            Leads assigned to <span className='fw-bold text-info'>{capitalizeFirstLetter(data.employee_name)}</span> have not been transferred.
                                            <br></br>
                                            Please take action or provide further instruction.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {is_transfer_all ? (
                                <>
                                    <div className="col-lg-12 mb-3">
                                        <label className="text-black font-w500 fs-7">Convert Staff <span className="required">*</span></label>
                                        <Select
                                            defaultValue={staff}
                                            onChange={setstaff}
                                            options={staffoption}
                                            placeholder="Select Convert Staff"
                                        />
                                        {errors.staff && <div className="text-danger fs-8 mt-1">{errors.staff}</div>}
                                    </div>

                                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                                        <button type="submit" className="btn btn-sm btn-danger" onClick={handleSubmitLeads}> <i className="fa-solid fa-people-arrows"></i> Transfer All</button>
                                    </div>
                                </>
                            ) : (
                                <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                                    <button type="submit" className="btn btn-sm btn-danger" onClick={handleAllTransfer}> <i className="fa-solid fa-people-arrows"></i> Transfer All</button>
                                    <button type="submit" className="btn btn-sm btn-info" onClick={handleManualTransfer} > <i className="fa-solid fa-arrows-down-to-people "></i> Transfer Manually</button>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default UserEdit;
